import { type ThemeOptions } from '@mui/material';

export function createTextareaStyles() {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.MuiInputBase-multiline fieldset legend': {
            transition: 'unset',
          },
        },
      },
    } as ThemeOptions['components'],
  };
}
